import styled from "@emotion/styled";
import React from "react";
import useWindowSize from "./hooks/useWindowSize";
import GridLayout from "./components/GridLayout";
import { breakpoints } from "./hooks/useBreakpoint";
import Crosses from "./components/Crosses";
import Header from "./components/Header";
import MainScreen from "./components/MainScreen";
import Footer from "./components/Footer";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
`;

function App() {
  const { width } = useWindowSize();

  return (
    <Wrapper>
      <GridLayout>
        {width >= breakpoints.lg && (
          <Crosses placement={"right"} gridArea={"crosses1"} />
        )}
        <Header />
        <MainScreen />
        <Footer />
        {width >= breakpoints.lg && (
          <Crosses placement={"left"} gridArea={"crosses2"} includeDeathy />
        )}
      </GridLayout>
    </Wrapper>
  );
}

export default App;
